import { useRequiredSelectedCompanyId } from "../../../hooks/useCompany";
import { useSelectedScheme } from "../../../hooks/useScheme";
import ReportExecutionList from "./ReportExecutionList";

interface ReportExecutionListContainerProps {
  jobId?: string;
}

function ReportExecutionListContainer(
  props: ReportExecutionListContainerProps,
) {
  const company = useRequiredSelectedCompanyId();
  const scheme = useSelectedScheme();

  return (
    <ReportExecutionList
      params={{ job_id: props.jobId }}
      company_id={company}
      scheme_id={scheme?.scheme_id}
    />
  );
}

export default ReportExecutionListContainer;
